export default "__VITE_ASSET__B1K71mom__"